/* eslint-disable functional/no-expression-statement, functional/immutable-data */
/* eslint-disable functional/no-class, functional/no-this-expression */
/* eslint-disable  functional/no-conditional-statement */
import _ from 'lodash';
import Transport from 'winston-transport';

const levels = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 4,
};

const methods = {
  error: 'error',
  warn: 'warn',
  info: 'info',
  debug: 'log',
};

export default class BrowserConsole extends Transport {
  constructor(opts) {
    super(opts);
    this.name = 'BrowserConsole';
    this.level = _.get(levels, opts.level, levels.info);
  }

  log(method, message) {
    setImmediate(() => {
      this.emit('logged', method);
    });

    const val = levels[method];
    const mappedMethod = methods[method];
    if (val <= this.level) {
      // eslint-disable-next-line no-console
      console[mappedMethod](message);
    }
  }
}
